export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-500 pt-14 pb-8">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-background-50 rounded-lg">
                <i className="ri-chat-smile-2-line text-primary-500 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 tracking-wide">
                今日吃瓜
              </span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              一站式吃瓜入口聚合平台，整合51今日吃瓜、今日吃瓜网、51吃瓜网、吃瓜在线、吃瓜大全、吃瓜平台等热门入口。每日必吃瓜料即时更新，全网吃瓜一键触达。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li><a href="#topics" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">热门瓜料</a></li>
              <li><a href="#ranking" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">吃瓜热度榜</a></li>
              <li><a href="#index" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">专题索引</a></li>
              <li><a href="#cards" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">吃瓜快讯</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              吃瓜入口
            </h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-background-50/70">51今日吃瓜</span></li>
              <li><span className="text-sm text-background-50/70">今日吃瓜网</span></li>
              <li><span className="text-sm text-background-50/70">51吃瓜网</span></li>
              <li><span className="text-sm text-background-50/70">吃瓜在线</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-50/50 italic">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; 2026 今日吃瓜 | 一站式吃瓜入口聚合平台。本站仅提供导航服务，不生产任何瓜料内容。
          </p>
          <p className="text-xs text-background-50/40">
            吃瓜虽好，理性为先 · 不信谣不传谣
          </p>
        </div>
      </div>
    </footer>
  );
}